// Central helpers + option lists for Service User (client) form + display.
// Keeps legacy string values and new array values both readable everywhere.

export const PRIMARY_NEEDS_OPTIONS = [
  "ADHD",
  "Autism Spectrum Condition",
  "Learning Disability",
  "Dementia",
  "Alzheimer's",
  "Epilepsy",
  "Diabetes (Type 1)",
  "Diabetes (Type 2)",
  "Mental Health",
  "Anxiety Disorder",
  "Depression",
  "Bipolar Disorder",
  "Schizophrenia",
  "Physical Disability",
  "Cerebral Palsy",
  "Down Syndrome",
  "Sensory Impairment",
  "Visual Impairment",
  "Hearing Impairment",
  "Acquired Brain Injury",
  "Stroke Recovery",
  "Parkinson's Disease",
  "Multiple Sclerosis",
  "Motor Neurone Disease",
  "COPD",
  "Heart Condition",
  "End of Life Care",
  "Palliative Care",
  "Substance Misuse Recovery",
  "Complex Nursing Needs",
];

// Allergy library with clinical severity. Colours are applied in the multi-select.
export const ALLERGY_OPTIONS = [
  { value: "Penicillin", severity: "severe" },
  { value: "Nuts (tree)", severity: "severe" },
  { value: "Peanuts", severity: "severe" },
  { value: "Shellfish", severity: "severe" },
  { value: "Latex", severity: "severe" },
  { value: "Bee/Wasp Sting", severity: "severe" },
  { value: "Contrast Dye", severity: "severe" },
  { value: "Eggs", severity: "moderate" },
  { value: "Dairy / Lactose", severity: "moderate" },
  { value: "Gluten / Wheat", severity: "moderate" },
  { value: "Fish", severity: "moderate" },
  { value: "Soy", severity: "moderate" },
  { value: "Sesame", severity: "moderate" },
  { value: "Aspirin", severity: "moderate" },
  { value: "Ibuprofen", severity: "moderate" },
  { value: "Sulfa Drugs", severity: "moderate" },
  { value: "Codeine", severity: "moderate" },
  { value: "Dust Mites", severity: "mild" },
  { value: "Pollen", severity: "mild" },
  { value: "Pet Dander", severity: "mild" },
  { value: "Mould", severity: "mild" },
];

export const NEXT_OF_KIN_RELATIONSHIPS = [
  "Spouse / Partner",
  "Parent",
  "Child",
  "Sibling",
  "Grandchild",
  "Grandparent",
  "Aunt / Uncle",
  "Cousin",
  "Guardian",
  "Friend",
  "Neighbour",
  "Solicitor",
  "Advocate",
  "Other",
];

// Severity → badge classes (light + dark mode).
export const ALLERGY_SEVERITY_STYLES = {
  severe: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800",
  moderate: "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800",
  mild: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800",
  unknown: "bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:border-slate-600",
};

export const getAllergySeverity = (value) => {
  const hit = ALLERGY_OPTIONS.find((o) => o.value.toLowerCase() === String(value || "").toLowerCase());
  return hit?.severity || "unknown";
};

// ---- Display helpers -------------------------------------------------------

const toArray = (v) => {
  if (Array.isArray(v)) return v.filter(Boolean);
  if (typeof v === "string" && v.trim()) {
    // Legacy: comma-separated string
    return v.split(",").map((s) => s.trim()).filter(Boolean);
  }
  return [];
};

/** Return a comma-joined string for tables / PDFs / legacy areas. */
export const formatListValue = (v) => toArray(v).join(", ");

/** Return an array — always. Used to render pills. */
export const asArray = toArray;
